import clsx from 'clsx';
import {
  section,
  container,
  content,
  titleText,
  descriptionText,
  leftArrow,
  rightArrow,
  arrow,
  slide,
  frame,
  frameActive,
  frameInactive,
  image,
  slideContainer,
} from './SobreClinica.styles';
import { useRef, useState, useEffect, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import clinicas from './SobreClinica.images';

export default function SobreClinica() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [isMobile, setIsMobile] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const handleArrowColor = useCallback(
    (valueToCompare) => {
      if (activeSlide === valueToCompare) return 'text-gray-300';
      return isMobile ? 'text-background' : 'text-title';
    },
    [activeSlide, isMobile]
  );

  return (
    <section className={section} id='clinica'>
      <div className={container}>
        {isMobile && <p className={titleText}>A Clínica</p>}

        <div className={content}>
          {!isMobile && <p className={titleText}>A Clínica</p>}
          <p className={descriptionText}>
            Nossa clínica foi planejada para oferecer um ambiente tranquilo e
            acolhedor, onde conforto e hospitalidade são prioridades.
          </p>
          <br />
          <p className={descriptionText}>
            Desde o momento em que você entra, cada detalhe é pensado para que
            sua experiência seja a mais agradável possível, fazendo com que você
            se sinta em casa.
          </p>
        </div>

        <div className={slideContainer}>
          <div ref={prevRef} className={`${arrow} ${leftArrow}`}>
            <IoIosArrowBack
              size={isMobile ? 30 : 40}
              className={handleArrowColor(0)}
            />
          </div>

          <div ref={nextRef} className={`${arrow} ${rightArrow}`}>
            <IoIosArrowForward
              className={handleArrowColor(clinicas.length - 1)}
              size={isMobile ? 30 : 40}
            />
          </div>

          <Swiper
            modules={[Navigation]}
            navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            spaceBetween={isMobile ? 10 : 30}
            slidesPerView={isMobile ? 1 : 1.5}
            centeredSlides={!isMobile}
            speed={800}
            className={clsx('rounded-xl', { 'w-full': isMobile })}
            onSlideChange={(swiper) => setActiveSlide(swiper.activeIndex)}
          >
            {clinicas.map((src, i) => (
              <SwiperSlide key={i} className={slide}>
                {({ isActive }) => (
                  <div
                    className={clsx(
                      frame,
                      isActive ? frameActive : frameInactive
                    )}
                  >
                    <img
                      src={src}
                      alt={`Clínica ${i + 1}`}
                      draggable={false}
                      onContextMenu={(e) => e.preventDefault()}
                      className={image}
                    />
                  </div>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}
